/**
 * Template variable definitions shared across the email editor.
 * Used by QuillEditor for the variable-insert dropdown.
 */
export var TEMPLATE_VARIABLES = [
  { label: 'First Name', value: '{{FIRST_NAME}}' },
  { label: 'Last Name', value: '{{LAST_NAME}}' },
  { label: 'Full Name', value: '{{FULL_NAME}}' },
  { label: 'Email', value: '{{EMAIL}}' },
  { label: 'Phone', value: '{{PHONE}}' },
  { label: 'School Name', value: '{{SCHOOL_NAME}}' },
  { label: 'Class Start Date', value: '{{CLASS_START_DATE}}' },
];
